import { ComponentProps } from "../types";
import { Button, Icon, Tooltip } from "@mui/material";
import DashboardPageContext from "../DashboardPageContext";
import { CSSProperties, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardEnvContext from "../DashboardEnvContext";

function Component({ component, evalJsText, evaluteScript }: ComponentProps) {
	const navigate = useNavigate();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dashboard = useContext(DashboardEnvContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);

	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties["width"]) style.width = component.properties["width"];
		return style;
	}, [component, exeMode]);

	const doNavigation = () => {
		try {
			const path = evalJsText(component.properties["path"]);
			if (path) navigate(path);
		} catch (error) {
			alert("Path evaluation failed: " + JSON.stringify(error));
		}
	};

	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		args["variant"] = (component.properties?.["variant"] || "text") as "text" | "elevation" | "outlined";
		args["color"] = (component.properties["color"] || "inherit") as "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
		if (component.properties["icon"]) args["startIcon"] = <Icon>{evalJsText(component.properties["icon"])}</Icon>;
		args["onClick"] = () => doNavigation();
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		if (component.properties["disabled"]) args["disabled"] = evaluteScript(component.properties["disabled"]);
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context, exeMode]);
	return (
		<Tooltip title={evalJsText(component.properties["tooltip"])}>
			<span>
				<Button key={component.id} {...args} style={style}>
					{evalJsText(component.properties["label"])}
				</Button>
			</span>
		</Tooltip>
	);
}

export default Component;
